import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './components/Home/Home'
import Error from './components/Error/Error'
import OrderConfrim from './components/OrderConfirm/OrderConfirm';












// create context



function App() {




  return (

      <Router>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/confirm' element={<OrderConfrim />} />
          <Route path='*' element={<Error/>} />

        </Routes>
      </Router>

  );
};

export default App;


